//@action-types
export const CHANGE_KANOON = 'CHANGE_KANOON'
